/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import includes from 'lodash/includes';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import compact from 'lodash/compact';
import { BookingStatusOption } from '~graphql/__generated__/globalTypes';
import { gtmDataLayer } from '~utils/use-checkout-stage';

const useTrackingCountry = (bookings: any) => {
  const invalidBookingStatus = [
    BookingStatusOption.CANCELLED,
    BookingStatusOption.EXPIRED,
    BookingStatusOption.PAST,
  ];

  const effectiveBookings = () => {
    const bookingsByDate = orderBy(
      bookings,
      (booking: any) => {
        return booking?.editInfo?.updatedAt || booking?.editInfo?.createdAt;
      },
      'desc'
    );

    const usefulBookings = compact(
      map(bookingsByDate, item => {
        const effectiveTrack = includes(invalidBookingStatus, item?.status);
        if (!effectiveTrack) return item;
      })
    );

    if (usefulBookings.length > 0) {
      return usefulBookings;
    }

    if (bookingsByDate.length > 0) {
      return [bookingsByDate[0]];
    }

    return [];
  };

  const handleChooseTrackingCountry = () => {
    let trackingCountry = { contentGroup: 'Checkout' };
    const effectiveTrackingBookings = effectiveBookings();
    if (effectiveTrackingBookings.length === 0) {
      return null;
    }

    map(effectiveTrackingBookings, (item, idx) => {
      if (idx === 0) {
        Object.assign(trackingCountry, { Country: item?.property?.country?.name });
        return item;
      }
      Object.assign(trackingCountry, { [`Country${idx}`]: item?.property?.country?.name });
      return item;
    });
    return trackingCountry;
  };

  useEffect(() => {
    if (!bookings) return;
    const sendTrackingCountry = handleChooseTrackingCountry();
    if (sendTrackingCountry) {
      gtmDataLayer(sendTrackingCountry);
    }
  }, [bookings]);
};

export default useTrackingCountry;
